import { render, staticRenderFns } from "./UiCheckSelectbox.vue?vue&type=template&id=4584bf08"
import script from "./UiCheckSelectbox.vue?vue&type=script&lang=js"
export * from "./UiCheckSelectbox.vue?vue&type=script&lang=js"
import style0 from "./UiCheckSelectbox.vue?vue&type=style&index=0&id=4584bf08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports